import { useEffect, useState } from "react";
import { usePinMode } from "./pinMode";

// Global modifier-key signal.
//  - `shift`: plain Shift held → "pick a favourite" mode (group tiles, tabs,
//    team / division / conference and league pickers).
//  - `ctrl`:  plain Ctrl/Cmd held → "pin a default" mode for page toggles.
// Listeners live inside the hook's effect (not a module singleton) so hot-reload
// can never leave a stale handler that stops updating the UI.
export function useShiftHold() {
    const [state, setState] = useState({ shift: false, ctrl: false });
    useEffect(() => {
        const set = (e) => {
            const s = !!e.shiftKey && !e.ctrlKey && !e.metaKey && !e.altKey;
            const c = (!!e.ctrlKey || !!e.metaKey) && !e.shiftKey && !e.altKey;
            setState((prev) => (prev.shift === s && prev.ctrl === c) ? prev : { shift: s, ctrl: c });
        };
        const clear = () => setState((prev) => (!prev.shift && !prev.ctrl) ? prev : { shift: false, ctrl: false });
        window.addEventListener("keydown", set);
        window.addEventListener("keyup", set);
        window.addEventListener("blur", clear);
        document.addEventListener("visibilitychange", clear);
        return () => {
            window.removeEventListener("keydown", set);
            window.removeEventListener("keyup", set);
            window.removeEventListener("blur", clear);
            document.removeEventListener("visibilitychange", clear);
        };
    }, []);
    const pin = usePinMode();
    return pin ? { ...state, shift: true } : state;
}

export function useShiftLong() {
    return useShiftHold().shift;
}
